if (!customElements.get('flyout-widget')) {
  class flyoutWidget extends HTMLElement {
    constructor() {
      super();
      this.toggle = this.querySelector('[data-toggle]');
      this.toggleText = this.toggle.querySelector('.js-text');
      this.openText = this.dataset.open;
      this.closeText = this.dataset.close;
    }

    connectedCallback() {
      this.toggle.addEventListener('click', () => {
        this.toggleFlyout();
      });
    }

    toggleFlyout() {
      this.classList.toggle('open');
      this.toggleText.textContent = this.classList.contains('open') ? this.closeText : this.openText;
    }
  }

  customElements.define('flyout-widget', flyoutWidget);
}
